import { LSL_AUTH_DATA, LSL_USER_ID_COOKIE } from 'config/constants';
import jscookie from 'js-cookie';

const getMemberIdFromLslCookies = () => {
  const memberId = jscookie.get(LSL_AUTH_DATA)?.split('|')?.[0];
  const uid = jscookie.get(LSL_USER_ID_COOKIE);

  return memberId || uid;
};

export default getMemberIdFromLslCookies;
